import { render, staticRenderFns } from "./followUp.vue?vue&type=template&id=51da662d&scoped=true&"
import script from "./followUp.vue?vue&type=script&lang=js&"
export * from "./followUp.vue?vue&type=script&lang=js&"
import style0 from "./followUp.vue?vue&type=style&index=0&id=51da662d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51da662d",
  null
  
)

export default component.exports